<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/200kW/200kW.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">200kW All-in-One Electric Drive Assembly</div>
                <div class="detail-banner-desc transmission">Multi-in-1 electric drive assembly integrating Motor + MCU + VCU +
                    Gearbox + OBC + DCDC + PDU

                    <div class="detail-desc">
                        <div>
                            Highly integrated system incorporates controllers for the MCU, DCDC, OBC, VCU, EOP, clutch
                            disconnect, and differential lock, and is compatible with neutral point boosting
                            functionality;<br />
                        </div>
                        <div>
                            It supports both 400V and 800V voltage platforms;<br />
                        </div>
                        <div>
                            All bearings utilize ball bearings to enhance efficiency;<br />
                        </div>
                        <div>
                            The integrated housing design for the motor, reducer, and controller reduces overall height
                            dimensions.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">

                <div class="one-titile">
                    Core Configuration-Voltge Platrorm:210~470V
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/200kW/200kW-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">6.6kW</div>
                                    <div class="k">OBC Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3kW</div>
                                    <div class="k">DCDC Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">200kW</div>
                                    <div class="k">Max Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">22000rpm</div>
                                    <div class="k">Max Speed</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3500N·m</div>
                                    <div class="k">Max Wheel Torque</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">88kg</div>
                                    <div class="k">Weight</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">90.5%</div>
                                    <div class="k">WLTC Efficiency</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Oil</div>
                                    <div class="k">Cooling</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration-Voltge Platrorm:340V~900V
                </div>
                <div class="spec-row">

                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">6.6kW/11kW</div>
                                    <div class="k">OBC Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3kW</div>
                                    <div class="k">DCDC Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">270kW</div>
                                    <div class="k">Max. Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">22000rpm</div>
                                    <div class="k">Max. Speed</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">4500N·m</div>
                                    <div class="k">Max. Wheel Torque</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">92kg</div>
                                    <div class="k">Weight</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">92.7%</div>
                                    <div class="k">WLTC Efficiency</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Oil</div>
                                    <div class="k">Cooling</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/200kW/200kW-2.jpg" alt="200-1-02">
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '200kW All-in-One Electric Drive Assembly - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/transmission/200.html'

};

import { createApp } from 'vue';
import App from './200.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./200.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
